<template>
  <ul class="tab">
    <li
      v-for="({ title, url }, index) in list"
      :key="index"
      @click="$router.push(url)"
      :class="{ active: $route.path == url }"
    >
      {{ title }}
    </li>
  </ul>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'

export default {
  name: 'ActivityTab',
  data() {
    return {
      list: [
        { title: '任务管理', url: '/home/activity/management' },
        { title: '任务类型管理', url: '/home/activity/typeManagement' },
        // { title: '黑名单管理', url: '/home/activity/blocklistManagement' },
        { title: '用户类型管理', url: '/home/activity/userTypeManagement' },
      ],
    }
  },

  methods: {},
  computed: {},
}
</script>

<style lang="less" scoped>
.tab {
  display: flex;
  list-style: none;
  gap: 16px;
  padding: 0;
  li {
    cursor: pointer;
    &:hover {
      color: #707aff;
    }
  }
  .active {
    color: #707aff;
  }
}
</style>
